import { useState } from "react";
import { HiX } from "react-icons/hi";
import { BiNavigation } from "react-icons/bi";

const FloatingMenu = ({ menuItems }) => {
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const toggleMenu = () => setIsMenuVisible(!isMenuVisible);
  const handleItemClick = () => setIsMenuVisible(false);

  return (
    /* PARENT: Now uses justify-start to sit at the top. 
       Added pt-20 to ensure it sits below common phone notches/headers.
    */
    <div className="fixed top-6 right-6 z-[49] flex flex-col items-end justify-start">
      
      {/* --- Main Toggle Button (FAB) --- */}
      {/* Moved to the top of the flex-col */}
      <button
        onClick={toggleMenu}
        className={`
          pointer-events-auto
          group relative w-14 h-14 flex items-center justify-center rounded-2xl
          transition-opacity transition-transform duration-200 shadow-xl active:scale-90 z-20
          ${isMenuVisible 
            ? "bg-zinc-900 text-white rotate-90" 
            : "bg-white text-zinc-900 border border-gray-200"
          }
        `}
      >
        <div className="relative w-6 h-6 flex items-center justify-center">
           {isMenuVisible ? (
             <HiX size={24} />
           ) : (
             <div className="flex flex-col items-end gap-1.5">
                <div className="w-6 h-[2.5px] bg-zinc-900 rounded-full" />
                <div className="w-4 h-[2.5px] bg-zinc-900 rounded-full" />
                <div className="w-5 h-[2.5px] bg-zinc-900 rounded-full" />
             </div>
           )}
        </div>

       
      </button>

      {/* --- Floating Menu Card --- */}
      {/* Now appears AFTER the button, opening downward */}
      <div
        className={`
          absolute top-16 right-0 w-60 rounded-[2rem] overflow-hidden shadow-xl 
          transition-opacity transition-transform duration-200 ease-[cubic-bezier(0.16,1,0.3,1)] origin-top-right
          ${isMenuVisible 
            ? "opacity-100 scale-100 translate-y-0 pointer-events-auto" 
            : "opacity-0 scale-75 -translate-y-10 pointer-events-none"
          }
        `}
      >
        <div className="bg-zinc-900 border border-white/10 p-3">
          <div className="px-4 py-3 border-b border-white/5 mb-2">
            <p className="text-[9px] font-black uppercase tracking-[0.3em] text-amber-500/90">
              Quick Explore
            </p>
          </div>

          <ul className="max-h-[60vh] overflow-y-auto no-scrollbar space-y-1">
            {menuItems?.map((item, index) => (
              <li key={index}>
                <a
                  href={item.href}
                  onClick={handleItemClick}
                  className="group flex items-center justify-between px-4 py-3 rounded-2xl hover:bg-white/5 transition-opacity transition-transform duration-200"
                >
                  <span className="text-sm font-medium text-zinc-400 group-hover:text-white group-hover:translate-x-1 transition-transform">
                    {item.label}
                  </span>
                  <div className="w-6 h-6 rounded-full bg-white/0 group-hover:bg-amber-500/10 flex items-center justify-center transition-opacity transition-transform">
                    <BiNavigation className="text-zinc-700 group-hover:text-amber-500 transition-opacity transition-transform -rotate-45" size={14} />
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Background Overlay */}
      

      <style jsx>{`
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
};

export default FloatingMenu;